enum WebGLTextOrientation {

	BOTTOM_LEFT = 'BOTTOM_LEFT',
	BOTTOM_RIGHT = 'BOTTOM_RIGHT',
	TOP_LEFT = 'TOP_LEFT',
	TOP_RIGHT = 'TOP_RIGHT'
}

export default WebGLTextOrientation;


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/WebGLTextOrientation.ts